import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { SHIP_BY_OPTIONS } from "./clientFormHelpers";

const ShippingStep = ({ formData, handleChange }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Name" name="shippingName" value={formData.shippingName} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Contact" name="shippingContact" value={formData.shippingContact} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Address" name="shippingAddress" value={formData.shippingAddress} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Ship Address 2" name="shipAddress2" value={formData.shipAddress2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping City" name="shippingCity" value={formData.shippingCity} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping State" name="shippingState" value={formData.shippingState} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Zip" name="shippingZip" value={formData.shippingZip} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Country" name="shippingCountry" value={formData.shippingCountry} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Phone 1" name="shippingPhone1" value={formData.shippingPhone1} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Phone 2" name="shippingPhone2" value={formData.shippingPhone2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Fax" name="shippingFax" value={formData.shippingFax} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Email" name="shippingEmail" value={formData.shippingEmail} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Shipping Format" name="shippingFormat" value={formData.shippingFormat} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Ship By</InputLabel>
          <Select name="shipBy" value={formData.shipBy || ""} onChange={handleChange} label="Ship By">
            <MenuItem value=""><em>Select Shipping Method</em></MenuItem>
            {SHIP_BY_OPTIONS.map((v) => (
              <MenuItem key={v} value={v}>{v}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Route Frequency" name="routeFrequency" value={formData.routeFrequency} onChange={handleChange} fullWidth size="small" inputProps={{ maxLength: 100 }} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Route Collection</InputLabel>
          <Select label="Route Collection" name="routeCollection" value={formData.routeCollection || ""} onChange={handleChange}>
            <MenuItem value=""><em>None</em></MenuItem>
            <MenuItem value="Collect">Collect</MenuItem>
            <MenuItem value="Pickup">Pickup</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Routine Shipment" name="routineShipment" value={formData.routineShipment} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField label="Shipping Comments" name="shippingComments" value={formData.shippingComments} onChange={handleChange} fullWidth size="small" multiline rows={1} />
      </Grid>
    </Grid>
  );
};

export default ShippingStep;
